import React from "react";
import { inject, observer } from "mobx-react";
import HttpClient from "services/HttpClient";
import RadioButton from "blocks/filters/RadioButton";
import NO_AVA from 'styles/img/no-ava.png'


const QUIZ_ANSWERS = "/api/v1/answers/quize_result";

@inject("modal")
@inject("workshopDetails")
@observer
export default class QuizQuestions extends React.Component {
  state = {
    questionIndex: 0,
    questions: [],
    userAnswer: [],
    radiobuttonOne: false,
    radiobuttonTwo: false
  };

  componentDidMount() {
    this.getQuestions();
  }

  getQuestions = () => {
    let questions = [
      ...this.props.workshopDetails.workshop.modules[this.props.modal.parentId]
        .questions
    ];
    let questionsNew = questions.map(el => {
      let newQuestion = {
        text: el.text,
        id: el.id
      };
      return newQuestion;
    });
    this.setState({
      questions: questionsNew,
      userAnswer: [...Array(questionsNew.length).fill().map(() => ({...{}}))],
    });
  };

  handleInputRadio = data => {
    const setter = data.index;
    this.setAnswer(setter);
  };

  setAnswer = setter => {
    const id = this.state.questions[this.state.questionIndex].id;
    let newAnswer = [...this.state.userAnswer];
    newAnswer[this.state.questionIndex].id = id;
    if (setter === "q_true") {
      newAnswer[this.state.questionIndex].answer = true;
      this.setState({
        userAnswer: newAnswer,
        radiobuttonOne: true,
        radiobuttonTwo: false
      });
    } else {
      newAnswer[this.state.questionIndex].answer = false;
      this.setState({
        userAnswer: newAnswer,
        radiobuttonOne: false,
        radiobuttonTwo: true
      });
    }
  };

  nextQuestion = () => {
    if (this.state.questionIndex < this.state.questions.length - 1) {
      this.setState({
        questionIndex: this.state.questionIndex + 1,
        radiobuttonOne: false,
        radiobuttonTwo: false
      });
    } else {
      let answers = this.state.userAnswer.reduce(
        (o, key) => ({ ...o, [key.id]: key.answer }),
        {}
      );

      let params = {
        workshop_id: this.props.workshopDetails.workshop.id,
        module_id: this.props.workshopDetails.workshop.modules[
          this.props.modal.parentId
        ].id,
        answers: answers
      };
      new HttpClient()
        .post(QUIZ_ANSWERS, params)
        .then(response => {
          this.showResults(response.body, this.props.modal.parentId);
        })
        .catch(() => {
          console.log("We are sorry but something went wrong");
        });
    }
  };

  showResults = (response, idx) => {
    this.props.modal.submitFunction(response, idx);
  };

  closeQuiz = () => {
    this.props.modal.toggleModal()
  }

  render() {
    const imgPath = () => {
      if (!this.props.workshopDetails.workshop.provider_logo_url) {
        return NO_AVA;
      } else {
        return String(this.props.workshopDetails.workshop.provider_logo_url);
      }
    };

    const noAnswerYet = () => {
      if (
        !Object.keys(this.state.userAnswer[this.state.questionIndex] || {}).length
      ) {
        return true;
      } else {
        return false;
      }
    };

    const questionText = () => {
      if (this.state.questions.length) {
        return this.state.questions[this.state.questionIndex].text;
      } else {
        return "Loading...";
      }
    };

    const nextButton = () => {
      if (this.state.questionIndex === (this.state.questions.length - 1)) {
        return "submit";
      }
      return "next question";
    };

    return (
      <div className="quiz-questions--container">
        <div className="quiz-questions--wrapper">
          <div className="close-btn" onClick={() => this.closeQuiz()}>
            <div className="close-btn-wrapper">
              <span />
              <span />
            </div>
          </div>
          <p className="question-counter">
            Question {this.state.questionIndex + 1} of {this.state.questions.length}
          </p>
          <div className="question--inner-block">
            <div className="provider--block">
              <img src={imgPath()} alt="face" />
              <div className="provider-text--block">
                <span className="provider-name">
                  {this.props.workshopDetails.workshop.provided_by}
                </span>
                <span className="provider-by">provider</span>
              </div>
            </div>
            <div className="question--block">
              <p className="actual-question">{questionText()}</p>
              <div className="answer-wrapper">
                <div className="quiz-radiogroup">
                  <RadioButton
                    key="1"
                    id="q_true"
                    label="True"
                    type="this_answer"
                    checked={this.state.radiobuttonOne}
                    handleChange={this.handleInputRadio}
                  />
                  <RadioButton
                    key="2"
                    id="q_false"
                    label="False"
                    type="this_answer"
                    checked={this.state.radiobuttonTwo}
                    handleChange={this.handleInputRadio}
                  />
                </div>
              </div>
              <button
                className="btn bordered"
                onClick={() => this.nextQuestion()}
                disabled={noAnswerYet()}
              >
                {nextButton()}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/QuizQuestions.jsx